export const PAY_PER_USE_MONTH_NAME_KEYS: readonly string[] = [
  'general.monthNames.january',
  'general.monthNames.february',
  'general.monthNames.march',
  'general.monthNames.april',
  'general.monthNames.may',
  'general.monthNames.june',
  'general.monthNames.july',
  'general.monthNames.august',
  'general.monthNames.september',
  'general.monthNames.october',
  'general.monthNames.november',
  'general.monthNames.december',
];
